<template>

  <t-page>

    <t-page-list :title="t('list-of') + currentPage.pageTitle" :user-auth="userAuth"
                 :total-pages="request.totalPages" :total-elements="request.totalElements" @getPage="getPage"
                 :breadcrumb="breadcrumb">

      <template #search>

        <b-button-group class="mr-3">

          <t-button v-if="userAuth.validation.validationCreate" :text="t('insert') + ' ' + currentPage.singularTitle"
                    :to="currentPage.name + '-form-new'" primary/>

          <t-dropdown v-if="userAuth.relationPages.length > 0"
                      variant="outline-primary" icon-settings
                      :items-relation-pages="userAuth.relationPages"/>

        </b-button-group>

        <t-content-header-search-default @searchChange="searchDefault"
                                         @onClearSearch="clearSearch()"
                                         :fields-custom="entityFieldCustomized('page')"
                                         :filtered-default="filteredDefault" :filtered-advanced="filteredAdvanced"
                                         :search-form="form">

          <t-input-search v-model="form.typeSpotDetailId"
                          :options="typeSpotDetailOptions"
                          label="Agrupamento Detalhes" select/>

        </t-content-header-search-default>

      </template>


      <t-table :show="checkViewListTableDefault()" @reload="reloadPageList()"
               :filtered="checkIsFiltered()"
               :busy="!pageListIsLoaded"
               :items="request.content"
               :user-auth="userAuth"
               :fields="userAuth.viewFields"
               primary-key-column="spotDetailNumber" link-primary-column="name"/>

    </t-page-list>

  </t-page>

</template>
<script>
import pageDefaultMixin from "@/mixins/page/pageDefaultMixin"
import pageListMixin from "@/mixins/page/pageListMixin"
import typeSpotDetailService from "@/services/modules/place/TypeSpotDetail.service";

export default {
  mixins: [pageDefaultMixin, pageListMixin],
  name: 'SpotDetail',
  data() {
    return {
      path: "", //Utilizar somente quando fora do padrão
      enableGeneralFields: true,
      form: {
        typeSpotDetailId: 0,
      },
      //--------------------------------------------------------------------------------------
      //Início de campos personalizados desta tela
      typeSpotDetailOptions: [],

      //--------------------------------------------------------------------------------------
    }
  },
  methods: {

    mountedPrepare() {

      this.breadcrumb = [
        {text: 'Configurações', to: {name: 'place-setting'}},
      ]

    },
    async mountedContinued() {

      await typeSpotDetailService.selectList().then((list) => {
        this.typeSpotDetailOptions = list
      }).catch(error => this.responseError(error))

    },
    //--------------------------------------------------------------------------------------
    //Início de métodos personalizados desta tela


    //--------------------------------------------------------------------------------------

  },
  async mounted() {

    this.mountedPrepare()

    await this.mountedList()

    await this.mountedContinued()

  },
}
</script>

